import {css, Theme} from "@emotion/react";

import {Button} from "@pg-design/button-module";
import {elevation} from "@pg-design/elevation";
import {borderRadius, flexJustifyCenter, mh} from "@pg-design/helpers-css";
import {Picture} from "@pg-design/picture-module";
import {propertyOffer} from "@pg-mono/string-utils";

import {useOffersViewsUrl} from "../../../../hooks/use_offers_views_url";
import {GTMEventAction, hitGtmMapCtaEvent} from "../../../tracking/gtm_map_cta_event";

const mapCtaBackgroundDesktopImage = require("../../../../images/mid_listing_banners/map_cta_background_desktop.jpg");
const mapCtaBackgroundMobileImage = require("../../../../images/mid_listing_banners/map_cta_background_mobile.jpg");

interface IProps {
    id: string;
    offerCount: number | null;
    className?: string;
}

export const MidListingMapBanner = (props: IProps) => {
    const {mapUrl} = useOffersViewsUrl();

    if (!props.offerCount) {
        return null;
    }

    const onMapCtaBtnClick = () => {
        hitGtmMapCtaEvent(GTMEventAction.CLICK);
    };

    return (
        <a onClick={onMapCtaBtnClick} href={mapUrl}>
            <div data-id={props.id} css={wrapperStyle}>
                <Picture
                    css={[flexJustifyCenter, noInteractionStyle]}
                    sources={[
                        {minWidthPX: 0, src: mapCtaBackgroundMobileImage, height: 224, width: 740},
                        {minWidthPX: 600, src: mapCtaBackgroundDesktopImage, height: 224, width: 1536}
                    ]}
                    fit="cover"
                    alt="picture"
                />
                <Button variant="filled_secondary" css={buttonStyle}>
                    Zobacz {props.offerCount} {propertyOffer.accusative(props.offerCount)} na mapie
                </Button>
            </div>
        </a>
    );
};

const wrapperStyle = (theme: Theme) => css`
    ${mh("auto")};
    ${borderRadius(2)};
    ${elevation(2)};
    height: 24rem;
    width: 100%;
    max-width: 37.5rem;
    overflow: hidden;

    @media (min-width: ${theme.breakpoints.md}) {
        height: 22.5rem;
        max-width: 100%;
    }
`;

const noInteractionStyle = css`
    user-select: none;
    pointer-events: none;
`;

const buttonStyle = css`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
`;
import {css, Theme} from "@emotion/react";

import {Button} from "@pg-design/button-module";
import {elevation} from "@pg-design/elevation";
import {borderRadius, flexJustifyCenter, mh} from "@pg-design/helpers-css";
import {Picture} from "@pg-design/picture-module";
import {propertyOffer} from "@pg-mono/string-utils";

import {useOffersViewsUrl} from "../../../../hooks/use_offers_views_url";
import {GTMEventAction, hitGtmMapCtaEvent} from "../../../tracking/gtm_map_cta_event";

const mapCtaBackgroundDesktopImage = require("../../../../images/mid_listing_banners/map_cta_background_desktop.jpg");
const mapCtaBackgroundMobileImage = require("../../../../images/mid_listing_banners/map_cta_background_mobile.jpg");

interface IProps {
    id: string;
    offerCount: number | null;
    className?: string;
}

export const MidListingMapBanner = (props: IProps) => {
    const {mapUrl} = useOffersViewsUrl();

    if (!props.offerCount) {
        return null;
    }

    const onMapCtaBtnClick = () => {
        hitGtmMapCtaEvent(GTMEventAction.CLICK);
    };

    return (
        <a onClick={onMapCtaBtnClick} href={mapUrl}>
            <div data-id={props.id} css={wrapperStyle}>
                <Picture
                    css={[flexJustifyCenter, noInteractionStyle]}
                    sources={[
                        {minWidthPX: 0, src: mapCtaBackgroundMobileImage, height: 224, width: 740},
                        {minWidthPX: 600, src: mapCtaBackgroundDesktopImage, height: 224, width: 1536}
                    ]}
                    fit="cover"
                    alt="picture"
                />
                <Button variant="filled_secondary" css={buttonStyle}>
                    Zobacz {props.offerCount} {propertyOffer.accusative(props.offerCount)} na mapie
                </Button>
            </div>
        </a>
    );
};

const wrapperStyle = (theme: Theme) => css`
    ${mh("auto")};
    ${borderRadius(2)};
    ${elevation(2)};
    height: 24rem;
    width: 100%;
    max-width: 37.5rem;
    overflow: hidden;

    @media (min-width: ${theme.breakpoints.md}) {
        height: 22.5rem;
        max-width: 100%;
    }
`;

const noInteractionStyle = css`
    user-select: none;
    pointer-events: none;
`;

const buttonStyle = css`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
`;
